<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Plany urlopowe innych</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja planu urlopowego</template>
          <template v-else>Dodawanie planu urlopowego</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/plany-urlopowe-innych')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab :title="'Plan urlopowy'" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Zakres urlopowy:
            </h4>
            <validation-observer ref="holidays-plans-other-form" tag="form">
              <div class="form-group">
                <validation-provider
                  :rules="'required'"
                  name="date_start"
                  v-slot="{ errors }">
                  <label for="date_start">
                    Podaj przedział:
                  </label>
                  <date-picker
                    :class="['reservation-style', 'mr-2', (importantDate === true && !data.date_start) ? 'invalid-date' : '']"
                    v-model="range"
                    validate
                    range
                    valueType="format"
                    style="width: 100%"/>
                </validation-provider>
                <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !data.date_start">
                  To pole jest wymagane
                </div>
              </div>
              <div class="form-group">
                <label class="title-box" :for="data.parent_id">
                  Użytkownik:
                </label>
                <div class="form-control p-0">
                  <v-select
                    placeholder="Wybierz użytkownika"
                    :options="users"
                    v-model="data.user_id"
                    :reduce="user => user.id"
                    label="name">
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.name }} {{ option.last_name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.name }} {{ option.last_name }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from '../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const moment = require('moment');

export default {
  name: 'holidays-other-form',
  components: { DatePicker },
  computed: {
    accountPermissions () {
      return this.$store.getters.getAccount
    },
    allDataLoaded () {
      return this.loaded && this.loadedUsers;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        date_start: '',
        date_end: '',
        user_id: '',
        user_name: ''
      },
      loaded: false,
      loadError: false,
      showAccepted: false,
      range: [],
      users: [],
      loadedUsers: false,
      importantDate: false,
      moment
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
    this.loadAdditionalData();
  },
  created () {
    setTimeout(() => {
      this.calendarDate();
    }, 1000);
  },
  watch: {
    'range': function (data) {
      this.data.date_start = data[0] ? data[0] : this.data.date_start;
      this.data.date_end = data[1] ? data[1] : this.data.date_end;
    },
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    calendarDate () {
      this.range = [(this.data.date_start), (this.data.date_end)];
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/holidays-plans/users/item/',
        instanceFields: ['date_start', 'date_end', 'user_id', 'user_name'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/users/items',
        params: {
          pagination: false
        },
        outputKey: 'users',
        loadedKey: 'loadedUsers',
        errorKey: 'loadError'
      });
    },
    validateForm () {
      this.importantDate = true
      if (this.data.date_start && this.data.date_end && this.data.user_id) {
        FormUtils.validate(this.$refs['holidays-plans-other-form'], this.submitForm);
      } else {
        FormUtils.validate(this.$refs['holidays-plans-other-form']);
      }
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/holidays-plans/users/update/' + this.id : '/holidays-plans/users/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano plan urlopowy',
        successText: 'Plan urlopowy został dodany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja planu urlopowego nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/plany-urlopowe-innych')
        }
      });
    },
    prepareFormDataToSend() {
      return {
        date_start: this.range[0] ? this.range[0] : this.data.date_start,
        date_end: this.range[1] ? this.range[1] : this.data.date_end,
        user_id: this.data.user_id
      };
    }
  },
};
</script>
<style>
  @import "../../assets/scss/layout/holidays-children.scss";
</style>
